import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "react-bootstrap-typeahead/css/Typeahead.css";
import "react-bootstrap-typeahead/css/Typeahead.bs5.css";
import "./styles/bootstrap_custom.scss";
import "./styles/TimePicker.css";
import "react-clock/dist/Clock.css";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

import Login from "./components/pages/Login/Login";
import Registro from "./components/pages/Registro/Registro";
import Inicio from "./components/pages/Inicio/Inicio";
import Enrutador from "./components/pages/Enrutador/Enrutador";
import ListaPropietarios from "./components/pages/ListaPropietarios/ListaPropietarios";
import CrearPropietario from "./components/pages/CrearPropietario/CrearPropietario";
import EditarPropietario from "./components/pages/EditarPropietario/EditarPropietario";
import MostrarPropietario from "./components/pages/MostrarPropietario/MostrarPropietario";
import CrearMascota from "./components/pages/CrearMascota/CrearMascota";
import MostrarMascota from "./components/pages/MostrarMascota/MostrarMascota";
import EditarMascota from "./components/pages/EditarMascota/EditarMascota";
import ListaMascotas from "./components/pages/ListaMascotas/ListaMascotas";
import Servicios from "./components/pages/Servicios/Servicios";
import ListaServiciosGuarderia from "./components/pages/ListaServiciosGuarderia/ListaServiciosGuarderia";
import CrearServicioGuarderia from "./components/pages/CrearServicioGuarderia/CrearServicioGuarderia";
import ListaServiciosHotel from "./components/pages/ListaServiciosHotel/ListaServiciosHotel";
import CrearServicioHotel from "./components/pages/CrearServicioHotel/CrearServicioHotel";
import ListaServiciosEntrenamiento from "./components/pages/ListaServiciosEntrenamiento/ListaServiciosEntrenamiento";
import CrearServicioEntrenamiento from "./components/pages/CrearServicioEntrenamiento/CrearServicioEntrenamiento";
import ListaServiciosSpa from "./components/pages/ListaServiciosSpa/ListaServiciosSpa";
import CrearServicioSpa from "./components/pages/CrearServicioSpa/CrearServicioSpa";
import ListaServiciosTransporte from "./components/pages/ListaServiciosTransporte/ListaServiciosTransporte";
import CrearServicioTransporte from "./components/pages/CrearServicioTransporte/CrearServicioTransporte";
import EditarServicioGuarderia from "./components/pages/EditarServicioGuarderia/EditarServicioGuarderia";
import EditarServicioHotel from "./components/pages/EditarServicioHotel/EditarServicioHotel";
import EditarServicioEntrenamiento from "./components/pages/EditarServicioEntrenamiento/EditarServicioEntrenamiento";
import EditarServicioSpa from "./components/pages/EditarServicioSpa/EditarServicioSpa";
import EditarServicioTransporte from "./components/pages/EditarServicioTransporte/EditarServicioTransporte";
import ListaProductos from "./components/pages/ListaProductos/ListaProductos";
import CrearProducto from "./components/pages/CrearProducto/CrearProducto";
import EditarProducto from "./components/pages/EditarProducto/EditarProducto";
import Reservas from "./components/pages/Reservas/Reservas";
import ReservarGuarderia from "./components/pages/ReservarGuarderia/ReservarGuarderia";
import Asistencia from "./components/pages/Asistencia/Asistencia";
import CheckinAsistencia from "./components/pages/CheckinAsistencia/CheckinAsistencia";
import ProyeccionesAsistencia from "./components/pages/ProyeccionesAsistencia/ProyeccionesAsistencia";
import EditarCheckinAsistencia from "./components/pages/EditarCheckinAsistencia/EditarCheckinAsistencia";
import Ventas from "./components/pages/Ventas/Ventas";
import VentasPorPagar from "./components/pages/VentasPorPagar/VentasPorPagar";
import HistorialVentas from "./components/pages/HistorialVentas/HistorialVentas";
import Transporte from "./components/pages/Transporte/Asistencia";
import HojaDiariaTransporte from "./components/pages/HojaDiariaTransporte/HojaDiariaTransporte";
import PlaneacionTransporte from "./components/pages/PlaneacionTransporte/PlaneacionTransporte";
import ReservarHotel from "./components/pages/ReservarHotel/ReservarHotel";
import ReservarSpa from "./components/pages/ReservarSpa/ReservarSpa";
import ProyeccionesAsistenciaSpa from "./components/pages/ProyeccionesAsistenciaSpa/ProyeccionesAsistenciaSpa";
import CheckinAsistenciaSpa from "./components/pages/CheckinAsistenciaSpa/CheckinAsistenciaSpa";
import Compras from "./components/pages/Compras/Compras";
import Comprar from "./components/pages/Comprar/Comprar";
import Comunicaciones from "./components/pages/Comunicaciones/Comunicaciones";
import Analisis from "./components/pages/Analisis/Analisis";
import Finanzas from "./components/pages/AnalisisFinanzas/Finanzas";
import Operaciones from "./components/pages/AnalisisOperaciones/Operaciones";
import AsistenciasPorDias from "./components/pages/AsistenciasPorDias/AsistenciasPorDias";
import PlanesActivosPorDia from "./components/pages/PlanesActivosPorDia/PlanesActivosPorDia";
import PlanesActivos from "./components/pages/PlanesActivos/PlanesActivos";
import MascotasDesertoras from "./components/pages/MascotasDesertoras/MascotasDesertoras";
import VacunasVencidas from "./components/pages/VacunasVencidas/VacunasVencidas";
import IngresosPorMes from "./components/pages/IngresosPorMes/IngresosPorMes";
import IngresosPorDia from "./components/pages/IngresosPorDia/IngresosPorDia";
import IngresosPorPropietario from "./components/pages/IngresosPorPropietario/IngresosPorPropietario";
import DeudasPorPropietario from "./components/pages/DeudasPorPropietario/DeudasPorPropietario";
import IngresosPorMascota from "./components/pages/IngresosPorMascota/IngresosPorMascota";
import IngresosPorServicio from "./components/pages/IngresosPorServicio/IngresosPorServicio";
import DescuentosPorMes from "./components/pages/DescuentosPorMes/DescuentosPorMes";
import ReporteDiario from "./components/pages/ReporteDiario/ReporteDiario";
import CorreosMasivos from "./components/pages/CorreosMasivos/CorreosMasivos";
import ServiciosYProductos from "./components/pages/ServiciosYProductos/ServiciosYProductos";
import PropietariosYMascotas from "./components/pages/PropietariosYMascotas/PropietariosYMascotas";
import Carrito from "./components/pages/Carrito/Carrito";
import MostrarVenta from "./components/pages/MostrarVenta/MostrarVenta";
import AuthGuard from "./components/AuthGuard";
import NoAutorizada from "./components/pages/NoAutorizada/NoAutorizada";
import ReservasGuarderia from "./components/pages/ReservasGuarderia/ReservasGuarderia";
import ListaAgendamientosGuarderia from "./components/pages/ListaAgendamientosGuarderia/ListaAgendamientosGuarderia";
import MostrarAgendamientoGuarderia from "./components/pages/MostrarAgendamientoGuarderia/MostrarAgendamientoGuarderia";
import ReservasHotel from "./components/pages/ReservasHotel/ReservasHotel";
import ListaAgendamientosHotel from "./components/pages/ListaAgendamientosHotel/ListaAgendamientosHotel";
import MostrarAgendamientoHotel from "./components/pages/MostrarAgendamientoHotel/MostrarAgendamientoHotel";
import ReservasSpa from "./components/pages/ReservasSpa/ReservasSpa";
import ListaAgendamientosSpa from "./components/pages/ListaAgendamientosSpa/ListaAgendamientosSpa";
import MostrarAgendamientoSpa from "./components/pages/MostrarAgendamientoSpa/MostrarAgendamientoSpa";
import CancelarAgendamientoGuarderia from "./components/pages/CancelarAgendamientoGuarderia/CancelarAgendamientoGuarderia";
import CancelarAgendamientoHotel from "./components/pages/CancelarAgendamientoHotel/CancelarAgendamientoHotel";
import Seguridad from "./components/pages/Seguridad/Seguridad";
import AsignarRoles from "./components/pages/AsignarRoles/AsignarRoles";
import AdministrarUsuarios from "./components/pages/AdministrarUsuarios/AdministrarUsuarios";
import OAuthGoogleCallback from "./components/pages/OAuthGoogleCallback/OAuthGoogleCallback";

import {
  RUTA_CARRITO,
  RUTA_COMPRAS,
  RUTA_COMPRAS_COMPRAR,
  RUTA_INICIO,
  RUTA_PROPIETARIOS_MASCOTAS,
  RUTA_PROPIETARIOS,
  RUTA_PROPIETARIOS_CREAR,
  RUTA_PROPIETARIOS_MASCOTAS_CREAR,
  RUTA_PROPIETARIOS_ID,
  RUTA_PROPIETARIOS_EDITAR,
  RUTA_MASCOTAS,
  RUTA_MASCOTAS_ID,
  RUTA_MASCOTAS_EDITAR,
  RUTA_SERVICIOS,
  RUTA_SERVICIOS_PRODUCTOS,
  RUTA_SERVICIOS_GUARDERIA,
  RUTA_SERVICIOS_GUARDERIA_CREAR,
  RUTA_SERVICIOS_HOTEL,
  RUTA_SERVICIOS_HOTEL_CREAR,
  RUTA_SERVICIOS_ENTRENAMIENTO,
  RUTA_SERVICIOS_ENTRENAMIENTO_CREAR,
  RUTA_SERVICIOS_SPA,
  RUTA_SERVICIOS_SPA_CREAR,
  RUTA_SERVICIOS_TRANSPORTE,
  RUTA_SERVICIOS_TRANSPORTE_CREAR,
  RUTA_SERVICIOS_GUARDERIA_ID,
  RUTA_SERVICIOS_HOTEL_ID,
  RUTA_SERVICIOS_ENTRENAMIENTO_ID,
  RUTA_SERVICIOS_SPA_ID,
  RUTA_SERVICIOS_TRANSPORTE_ID,
  RUTA_PRODUCTOS,
  RUTA_PRODUCTOS_CREAR,
  RUTA_PRODUCTOS_ID,
  RUTA_RESERVAS,
  RUTA_RESERVAS_GUARDERIA,
  RUTA_RESERVAS_GUARDERIA_CREAR,
  RUTA_RESERVAS_GUARDERIA_LISTAR,
  RUTA_RESERVAS_GUARDERIA_ID,
  RUTA_RESERVAS_GUARDERIA_CANCELAR,
  RUTA_RESERVAS_HOTEL,
  RUTA_RESERVAS_HOTEL_CREAR,
  RUTA_RESERVAS_HOTEL_LISTAR,
  RUTA_RESERVAS_HOTEL_ID,
  RUTA_RESERVAS_HOTEL_CANCELAR,
  RUTA_RESERVAS_SPA,
  RUTA_RESERVAS_SPA_CREAR,
  RUTA_RESERVAS_SPA_LISTAR,
  RUTA_RESERVAS_SPA_ID,
  RUTA_ASISTENCIA,
  RUTA_ASISTENCIA_CHECKIN,
  RUTA_ASISTENCIA_SPA_CHECKIN,
  RUTA_ASISTENCIA_CHECKIN_ID,
  RUTA_ASISTENCIA_PROYECCIONES,
  RUTA_ASISTENCIA_SPA_PROYECCIONES,
  RUTA_VENTAS,
  RUTA_VENTAS_ID,
  RUTA_VENTAS_POR_PAGAR,
  RUTA_VENTAS_HISTORIAL,
  RUTA_TRANSPORTE,
  RUTA_TRANSPORTE_HOY,
  RUTA_TRANSPORTE_PLANEACION,
  RUTA_COMUNICACIONES,
  RUTA_COMUNICACIONES_REPORTE_DIARIO,
  RUTA_COMUNICACIONES_CORREOS_MASIVOS,
  RUTA_COMUNICACIONES_CORREOS_MASIVOS_PLANTILLA,
  RUTA_ANALISIS,
  RUTA_ANALISIS_FINANZAS,
  RUTA_ANALISIS_OPERACIONES,
  RUTA_ANALISIS_OPERACIONES_ASISTENCIAS_POR_DIAS,
  RUTA_ANALISIS_OPERACIONES_PLANES_ACTIVOS_POR_DIA,
  RUTA_ANALISIS_OPERACIONES_PLANES_ACTIVOS,
  RUTA_ANALISIS_OPERACIONES_MASCOTAS_DESERTORAS,
  RUTA_ANALISIS_OPERACIONES_VACUNAS_VENCIDAS,
  RUTA_ANALISIS_FINANZAS_INGRESOS_POR_MES,
  RUTA_ANALISIS_FINANZAS_INGRESOS_POR_DIA,
  RUTA_ANALISIS_FINANZAS_INGRESOS_POR_PROPIETARIO,
  RUTA_ANALISIS_FINANZAS_DEUDAS_POR_PROPIETARIO,
  RUTA_ANALISIS_FINANZAS_INGRESOS_POR_MASCOTA,
  RUTA_ANALISIS_FINANZAS_INGRESOS_POR_SERVICIO,
  RUTA_ANALISIS_FINANZAS_DESCUENTOS_POR_MES,
  RUTA_ANALISIS_ENGLISH,
  RUTA_SEGURIDAD,
  RUTA_SEGURIDAD_ASIGNAR_ROLES,
  RUTA_SEGURIDAD_ADMINISTRAR_USUARIOS,
  RUTA_NO_AUTORIZADA,
  RUTA_OAUTH_GOOGLE_CALLBACK,
} from "./services/rutas";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

const queryClient = new QueryClient();

root.render(
  <QueryClientProvider client={queryClient}>
    <BrowserRouter>
      <Routes>
        <Route element={<AuthGuard />}>
          <Route path={RUTA_CARRITO} element={<Carrito />} />
          <Route path={RUTA_COMPRAS} element={<Compras />} />
          <Route path={RUTA_COMPRAS_COMPRAR} element={<Comprar />} />
          <Route path={RUTA_INICIO} element={<Inicio />} />
          <Route
            path={RUTA_PROPIETARIOS_MASCOTAS}
            element={<PropietariosYMascotas />}
          />
          <Route path={RUTA_PROPIETARIOS} element={<ListaPropietarios />} />
          <Route path={RUTA_PROPIETARIOS_CREAR} element={<CrearPropietario />} />
          <Route
            path={RUTA_PROPIETARIOS_MASCOTAS_CREAR}
            element={<CrearMascota />}
          />
          <Route
            path={RUTA_PROPIETARIOS_ID}
            element={<MostrarPropietario />}
          />
          <Route
            path={RUTA_PROPIETARIOS_EDITAR}
            element={<EditarPropietario />}
          />
          <Route path={RUTA_MASCOTAS} element={<ListaMascotas />} />
          <Route path={RUTA_MASCOTAS_ID} element={<MostrarMascota />} />
          <Route
            path={RUTA_MASCOTAS_EDITAR}
            element={<EditarMascota />}
          />
          <Route path={RUTA_SERVICIOS} element={<Servicios />} />
          <Route
            path={RUTA_SERVICIOS_PRODUCTOS}
            element={<ServiciosYProductos />}
          />
          <Route
            path={RUTA_SERVICIOS_GUARDERIA}
            element={<ListaServiciosGuarderia />}
          />
          <Route
            path={RUTA_SERVICIOS_GUARDERIA_CREAR}
            element={<CrearServicioGuarderia />}
          />
          <Route path={RUTA_SERVICIOS_HOTEL} element={<ListaServiciosHotel />} />
          <Route
            path={RUTA_SERVICIOS_HOTEL_CREAR}
            element={<CrearServicioHotel />}
          />
          <Route
            path={RUTA_SERVICIOS_ENTRENAMIENTO}
            element={<ListaServiciosEntrenamiento />}
          />
          <Route
            path={RUTA_SERVICIOS_ENTRENAMIENTO_CREAR}
            element={<CrearServicioEntrenamiento />}
          />
          <Route path={RUTA_SERVICIOS_SPA} element={<ListaServiciosSpa />} />
          <Route path={RUTA_SERVICIOS_SPA_CREAR} element={<CrearServicioSpa />} />
          <Route
            path={RUTA_SERVICIOS_TRANSPORTE}
            element={<ListaServiciosTransporte />}
          />
          <Route
            path={RUTA_SERVICIOS_TRANSPORTE_CREAR}
            element={<CrearServicioTransporte />}
          />
          <Route
            path={RUTA_SERVICIOS_GUARDERIA_ID}
            element={<EditarServicioGuarderia />}
          />
          <Route
            path={RUTA_SERVICIOS_HOTEL_ID}
            element={<EditarServicioHotel />}
          />
          <Route
            path={RUTA_SERVICIOS_ENTRENAMIENTO_ID}
            element={<EditarServicioEntrenamiento />}
          />
          <Route
            path={RUTA_SERVICIOS_SPA_ID}
            element={<EditarServicioSpa />}
          />
          <Route
            path={RUTA_SERVICIOS_TRANSPORTE_ID}
            element={<EditarServicioTransporte />}
          />
          <Route path={RUTA_PRODUCTOS} element={<ListaProductos />} />
          <Route path={RUTA_PRODUCTOS_CREAR} element={<CrearProducto />} />
          <Route path={RUTA_PRODUCTOS_ID} element={<EditarProducto />} />
          <Route path={RUTA_RESERVAS} element={<Reservas />} />
          <Route path={RUTA_RESERVAS_GUARDERIA} element={<ReservasGuarderia />} />
          <Route
            path={RUTA_RESERVAS_GUARDERIA_CREAR}
            element={<ReservarGuarderia />}
          />
          <Route
            path={RUTA_RESERVAS_GUARDERIA_LISTAR}
            element={<ListaAgendamientosGuarderia />}
          />
          <Route
            path={RUTA_RESERVAS_GUARDERIA_ID}
            element={<MostrarAgendamientoGuarderia />}
          />
          <Route
            path={RUTA_RESERVAS_GUARDERIA_CANCELAR}
            element={<CancelarAgendamientoGuarderia />}
          />
          <Route path={RUTA_RESERVAS_HOTEL} element={<ReservasHotel />} />
          <Route path={RUTA_RESERVAS_HOTEL_CREAR} element={<ReservarHotel />} />
          <Route
            path={RUTA_RESERVAS_HOTEL_LISTAR}
            element={<ListaAgendamientosHotel />}
          />
          <Route
            path={RUTA_RESERVAS_HOTEL_ID}
            element={<MostrarAgendamientoHotel />}
          />
          <Route
            path={RUTA_RESERVAS_HOTEL_CANCELAR}
            element={<CancelarAgendamientoHotel />}
          />
          <Route path={RUTA_RESERVAS_SPA} element={<ReservasSpa />} />
          <Route path={RUTA_RESERVAS_SPA_CREAR} element={<ReservarSpa />} />
          <Route
            path={RUTA_RESERVAS_SPA_LISTAR}
            element={<ListaAgendamientosSpa />}
          />
          <Route
            path={RUTA_RESERVAS_SPA_ID}
            element={<MostrarAgendamientoSpa />}
          />

          <Route path={RUTA_ASISTENCIA} element={<Asistencia />} />
          <Route path={RUTA_ASISTENCIA_CHECKIN} element={<CheckinAsistencia />} />
          <Route
            path={RUTA_ASISTENCIA_SPA_CHECKIN}
            element={<CheckinAsistenciaSpa />}
          />
          <Route
            path={RUTA_ASISTENCIA_CHECKIN_ID}
            element={<EditarCheckinAsistencia />}
          />
          <Route
            path={RUTA_ASISTENCIA_PROYECCIONES}
            element={<ProyeccionesAsistencia />}
          />
          <Route
            path={RUTA_ASISTENCIA_SPA_PROYECCIONES}
            element={<ProyeccionesAsistenciaSpa />}
          />
          <Route path={RUTA_VENTAS} element={<Ventas />} />
          <Route path={RUTA_VENTAS_ID} element={<MostrarVenta />} />
          <Route path={RUTA_VENTAS_POR_PAGAR} element={<VentasPorPagar />} />
          <Route path={RUTA_VENTAS_HISTORIAL} element={<HistorialVentas />} />

          <Route path={RUTA_TRANSPORTE} element={<Transporte />} />
          <Route path={RUTA_TRANSPORTE_HOY} element={<HojaDiariaTransporte />} />
          <Route
            path={RUTA_TRANSPORTE_PLANEACION}
            element={<PlaneacionTransporte />}
          />
          <Route path={RUTA_COMUNICACIONES} element={<Comunicaciones />} />
          <Route
            path={RUTA_COMUNICACIONES_REPORTE_DIARIO}
            element={<ReporteDiario />}
          />
          <Route
            path={RUTA_COMUNICACIONES_CORREOS_MASIVOS}
            element={<CorreosMasivos />}
          />
          <Route
            path={RUTA_COMUNICACIONES_CORREOS_MASIVOS_PLANTILLA}
            element={<CorreosMasivos />}
          />
          <Route path={RUTA_ANALISIS} element={<Analisis />} />
          <Route path={RUTA_ANALISIS_FINANZAS} element={<Finanzas />} />
          <Route path={RUTA_ANALISIS_OPERACIONES} element={<Operaciones />} />
          <Route
            path={RUTA_ANALISIS_OPERACIONES_ASISTENCIAS_POR_DIAS}
            element={<AsistenciasPorDias />}
          />
          <Route
            path={RUTA_ANALISIS_OPERACIONES_PLANES_ACTIVOS_POR_DIA}
            element={<PlanesActivosPorDia />}
          />
          <Route
            path={RUTA_ANALISIS_OPERACIONES_PLANES_ACTIVOS}
            element={<PlanesActivos />}
          />
          <Route
            path={RUTA_ANALISIS_OPERACIONES_MASCOTAS_DESERTORAS}
            element={<MascotasDesertoras />}
          />
          <Route
            path={RUTA_ANALISIS_OPERACIONES_VACUNAS_VENCIDAS}
            element={<VacunasVencidas />}
          />
          <Route
            path={RUTA_ANALISIS_FINANZAS_INGRESOS_POR_MES}
            element={<IngresosPorMes />}
          />
          <Route
            path={RUTA_ANALISIS_FINANZAS_INGRESOS_POR_DIA}
            element={<IngresosPorDia />}
          />
          <Route
            path={RUTA_ANALISIS_FINANZAS_INGRESOS_POR_PROPIETARIO}
            element={<IngresosPorPropietario />}
          />
          <Route
            path={RUTA_ANALISIS_FINANZAS_DEUDAS_POR_PROPIETARIO}
            element={<DeudasPorPropietario />}
          />
          <Route
            path={RUTA_ANALISIS_FINANZAS_INGRESOS_POR_MASCOTA}
            element={<IngresosPorMascota />}
          />
          <Route
            path={RUTA_ANALISIS_FINANZAS_INGRESOS_POR_SERVICIO}
            element={<IngresosPorServicio />}
          />
          <Route
            path={RUTA_ANALISIS_FINANZAS_DESCUENTOS_POR_MES}
            element={<DescuentosPorMes />}
          />
          <Route path={RUTA_ANALISIS_ENGLISH} element={<Analisis />} />
          <Route path={RUTA_SEGURIDAD} element={<Seguridad />} />
          <Route path={RUTA_SEGURIDAD_ASIGNAR_ROLES} element={<AsignarRoles />} />
          <Route
            path={RUTA_SEGURIDAD_ADMINISTRAR_USUARIOS}
            element={<AdministrarUsuarios />}
          />
          <Route path={RUTA_NO_AUTORIZADA} element={<NoAutorizada />} />
        </Route>
        <Route path="/" element={<Enrutador />} />
        <Route path="/login" element={<Login />} />
        <Route path={RUTA_OAUTH_GOOGLE_CALLBACK} element={<OAuthGoogleCallback />} />
        <Route path="/registro" element={<Registro />} />
      </Routes>
    </BrowserRouter>
  </QueryClientProvider>
);
